// Search-syntax help shown under the IBO search box in Order History and
// Create Order. This is static UI copy, not data — it used to live in
// mocks/mocks.js alongside a fabricated order/IBO dataset, which meant two
// production components imported from a `mocks/` module. The fabricated data
// was dead (only these tips were ever read), so it was deleted and the copy
// moved here.
export const orderHistoryTips = [
  {
    title: "Search by name",
    pre: "Enter",
    chip: "contact:<name>",
    post: "or just the name.",
  },
  {
    title: "Search by IBO number",
    pre: "Enter",
    chip: "ibo:<number>",
    post: "or just an IBO number.",
  },
];

export default orderHistoryTips;
